import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { adjustDateFormatAsPerPCalendar, ConfirmDialogModel, ConfirmDialogPopupComponent, CrudService, CURRENT_YEAR_TO_NEXT_FIFTY_YEARS, HttpCancelService, IApplicationResponse, ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, prepareRequiredHttpParams, RxjsService, setMinMaxDateValidator, SnackbarService } from '@app/shared';
import { MomentService } from '@app/shared/services/moment.service';
import { ActualTimingListModel, ActualTimingModel } from '@modules/customer/models/actual-timing.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';

@Component({
  selector: 'app-actual-time-dialog',
  templateUrl: './actual-time-dialog.component.html'
})
export class ActualTimeDialogComponent implements OnInit {

  actualTimingForm!: FormGroup;
  actualTimingDateList = [];
  todayDate = new Date();
  startAppointmentDate = new Date();
  endAppointmentDate = new Date();

  constructor(private rxjsService: RxjsService, private httpCancelService: HttpCancelService, public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig, private crudService: CrudService, private dialog: MatDialog,
    private momentService: MomentService, private snackbarService: SnackbarService, private formBuilder: FormBuilder,) {
      this.startAppointmentDate = new Date(config?.data?.startAppointmentDate);
      this.endAppointmentDate = new Date(config?.data?.endAppointmentDate);
  }

  ngOnInit(): void {
    this.loadActualTimings()
  }

  btnCloseClick() {
    this.rxjsService.setDialogOpenProperty(false);
    this.dialogRef.close(false);
  }

  loadActualTimings() {
    this.actualTimingDateList = this.config?.data?.actualTimingDateList;
    this.createActualTimingForm()
    let actualTimingModel = new ActualTimingModel(this.config?.data?.actualTimingModelData);
    if (this.config?.data?.actualTimingModelData.length == 0) {
      let actualTimingListModel = new ActualTimingListModel(null);
      actualTimingListModel.appointmentId = this.config?.data?.initiationDetailsData?.appointmentInfo?.appointmentId ? this.config?.data?.initiationDetailsData?.appointmentInfo?.appointmentId : '';
      actualTimingListModel.onRouteDate = "";
      actualTimingListModel.createdUserId = this.config?.data?.userData.userId ? this.config?.data?.userData.userId : '';
      actualTimingListModel.modifiedUserId = this.config?.data?.userData.userId ? this.config?.data?.userData.userId : '';
      actualTimingListModel.appointmentLogId = ''; // added for appointmentLogId date
      this.getactualTimingListArray.push(this.createactualTimingListModel(actualTimingListModel));;
    } else {
      this.config?.data?.actualTimingModelData?.forEach((actualTimingListModel: ActualTimingListModel) => {
        actualTimingListModel.appointmentId = this.config?.data?.initiationDetailsData?.appointmentInfo?.appointmentId ? this.config?.data?.initiationDetailsData?.appointmentInfo?.appointmentId : ''
        actualTimingListModel.onRouteTime = actualTimingListModel?.onRouteTime ? this.momentService.setTime(actualTimingListModel.onRouteTime) : null,
          actualTimingListModel.startTime = actualTimingListModel?.startTime ? this.momentService.setTime(actualTimingListModel.startTime) : null,
          actualTimingListModel.endTime = actualTimingListModel?.endTime ? this.momentService.setTime(actualTimingListModel.endTime) : null,
          actualTimingListModel.createdUserId = this.config?.data?.userData?.userId ? this.config?.data?.userData.userId : ''
        actualTimingListModel.modifiedUserId = this.config?.data?.userData?.userId ? this.config?.data?.userData.userId : '';
        actualTimingListModel.appointmentLogId = actualTimingListModel?.appointmentLogId ? actualTimingListModel.appointmentLogId : ''; // added for appointmentLogId date
        actualTimingListModel.onRouteDate = actualTimingListModel?.onRouteDate ? new Date(actualTimingListModel.onRouteDate) : '';
        actualTimingListModel.startTimeMinDate = actualTimingListModel?.onRouteTime ? this.momentService.toMoment(this.momentService.addMinits(actualTimingListModel.onRouteTime, 1)).seconds(0).format() : null;
        actualTimingListModel.endTimeMinDate = actualTimingListModel?.startTime ? this.momentService.toMoment(this.momentService.addMinits(actualTimingListModel.startTime, 1)).seconds(0).format() : null,
          this.getactualTimingListArray.push(this.createactualTimingListModel(actualTimingListModel));
      });
    }

  }

  isFormDisabled() {
    if (this.config?.data?.isInvoiced || this.config?.data?.isVoid) {
      return true
    } else {
      return false
    }
  }

  onEnableSubmit() {
    return this.config?.data?.actualTimingModelData?.every((el: any) => el?.startTime && el?.endTime) || this.config?.data?.actualTimingModelData?.every((el: any) => !el?.startTime);
  }

  createActualTimingForm(actualTimingModel?: ActualTimingModel) {
    let actualTimingModelControl: any = new ActualTimingModel(actualTimingModel);
    this.actualTimingForm = this.formBuilder.group({
      actualTimingList: this.formBuilder.array([])
    });
    Object.keys(actualTimingModelControl).forEach((key) => {
      this.actualTimingForm.addControl(key, new FormControl(actualTimingModelControl[key]));
    });

  }

  //Create FormArray
  get getactualTimingListArray(): FormArray | any {
    if (!this.actualTimingForm) return;
    return this.actualTimingForm.get("actualTimingList") as FormArray;
  }

  //Create FormArray controls
  createactualTimingListModel(actualTimingListModel?: ActualTimingListModel | any): FormGroup {
    let actualTimingListModelContol: any = new ActualTimingListModel(actualTimingListModel);
    let formControls: any = {};
    Object.keys(actualTimingListModelContol).forEach((key) => {
      if (key == 'onRouteDate') {
        formControls[key] = [{ value: actualTimingListModelContol[key], disabled: this.isFormDisabled() }, [Validators.required]]
      } else if (key == 'endTime') {
        formControls[key] = [{ value: actualTimingListModelContol[key], disabled: (this.isFormDisabled() && ((actualTimingListModelContol['startTime'] && actualTimingListModelContol[key]) || !actualTimingListModelContol['startTime'])) }]
      } else {
        formControls[key] = [{ value: actualTimingListModelContol[key], disabled: this.isFormDisabled() }]
      }
    });
    let formContrlsGroup = this.formBuilder.group(formControls)
    formContrlsGroup = setMinMaxDateValidator(formContrlsGroup, [
      { formControlName: 'onRouteTime', compareWith: 'startTime', type: 'minEqual' },
      { formControlName: 'startTime', compareWith: 'onRouteTime', type: 'maxEqual' },
      { formControlName: 'startTime', compareWith: 'endTime', type: 'minEqual' },
      { formControlName: 'endTime', compareWith: 'startTime', type: 'maxEqual' }
    ], 'HH:mm');
    formContrlsGroup.get('onRouteDate')?.valueChanges.subscribe(val => {
      this.todayDate = new Date();
      if (val) {
        let appointmentLogData = this.actualTimingDateList.find(element => element['displayName'] == val);
        formContrlsGroup.get('appointmentLogId')?.setValue(appointmentLogData ? appointmentLogData['id'] : '');
      } else {
        formContrlsGroup.get('appointmentLogId')?.setValue('');
      }
    })
    formContrlsGroup.get('onRouteTime')?.valueChanges.subscribe(val => {
      this.todayDate = new Date();
      if (!val) {
        formContrlsGroup.get('startTime')?.setValue(null, { emitEvent: true });
        formContrlsGroup.get('endTime')?.setValue(null, { emitEvent: true });
        formContrlsGroup.get('actualTime')?.setValue(null, { emitEvent: true });
        formContrlsGroup.get('startTimeMinDate')?.setValue(null, { emitEvent: true });
        formContrlsGroup.get('endTimeMinDate')?.setValue(null, { emitEvent: true });
        formContrlsGroup.get('startTime')?.clearValidators();
        formContrlsGroup.get('endTime')?.clearValidators();
        formContrlsGroup?.updateValueAndValidity();
        return;
      }
      let startTimeMinTime = this.momentService.toMoment(this.momentService.addMinits(val, 1)).seconds(0).format();
      formContrlsGroup.get('startTimeMinDate')?.setValue(startTimeMinTime, { emitEvent: true });
    })
    formContrlsGroup.get('startTime')?.valueChanges.subscribe(val => {
      this.todayDate = new Date();
      if (!val) {
        formContrlsGroup.get('endTime')?.setValue(null, { emitEvent: false });
        formContrlsGroup.get('actualTime')?.setValue(null, { emitEvent: true });
        formContrlsGroup.get('endTimeMinDate')?.setValue(null, { emitEvent: true });
        // formContrlsGroup.get('onRouteTime')?.setErrors(null);
        return
      }
      let endTimeMinTime = this.momentService.toMoment(this.momentService.addMinits(val, 1)).seconds(0).format();
      formContrlsGroup.get('endTimeMinDate')?.setValue(endTimeMinTime, { emitEvent: false });
      formContrlsGroup.markAllAsTouched();
      if (formContrlsGroup.get('endTime')?.value) {
        let addToMints1 = this.momentService.getTimeDiff(new Date(formContrlsGroup.get('startTime')?.value), new Date(formContrlsGroup.get('endTime')?.value))
        formContrlsGroup.get('actualTime')?.setValue(addToMints1);
      }
    })
    formContrlsGroup.get('endTime')?.valueChanges.subscribe(val => {
      this.todayDate = new Date();
      if (!val) {
        formContrlsGroup.get('actualTime')?.setValue(null, { emitEvent: true });
        return
      }
      if (!formContrlsGroup.get('startTime')?.value) {
        if (!formContrlsGroup.get('startTime')?.value) {
          formContrlsGroup.get('startTime')?.setErrors({ required: { formControlName: 'startTime' } });
        }
        formContrlsGroup.markAllAsTouched();
        return;
      }
      let addToMints1 = this.momentService.getTimeDiff(new Date(formContrlsGroup.get('startTime')?.value), new Date(formContrlsGroup.get('endTime')?.value))
      formContrlsGroup.get('actualTime')?.setValue(addToMints1);
    })
    return formContrlsGroup;
  }

  getDateFormat() {
    return adjustDateFormatAsPerPCalendar();
  }

  getYearRange(obj: any) {
    if (obj?.get('onRouteDate')?.value) {
      const startYearRange = obj?.get('onRouteDate')?.value.getFullYear();
      const endYearRange = startYearRange + 50;
      return `${startYearRange}:${endYearRange}`;
    } else {
      return CURRENT_YEAR_TO_NEXT_FIFTY_YEARS;
    }
  }

  getStartMinDate(obj: any) {
    return obj?.get('startTimeMinDate')?.value ? new Date(obj?.get('startTimeMinDate')?.value) : null;
  }

  getEndMinDate(obj: any) {
    return obj?.get('endTimeMinDate')?.value ? new Date(obj?.get('endTimeMinDate')?.value) : null;
  }

  onValidateExistTime() {
    let findArr = [];
    this.getactualTimingListArray.getRawValue()?.forEach((element: any, i: number) => {
      this.getactualTimingListArray.getRawValue()?.forEach((element1: any, j: number) => {
        if (i != j) {
          let isSameDay = this.momentService.isSameDay(element.onRouteDate, element1.onRouteDate)
          if (isSameDay) {
            let currentStartTime = this.momentService.toMoment(element1.startTime).seconds(0).format();
            let exist = this.momentService.betWeenDateTime(element.startTime, element.endTime, new Date(currentStartTime));
            let isStartSameDay = this.momentService.isSameDayTime(element.startTime, new Date(currentStartTime));
            let isEndSameDay = this.momentService.isSameDayTime(element.endTime, new Date(currentStartTime));
            if (exist || isStartSameDay || isEndSameDay) {
              findArr.push(true);
            }
            let currentEndTime = this.momentService.toMoment(element1.endTime).seconds(0).format();
            let existEndTime = this.momentService.betWeenDateTime(element.startTime, element.endTime, new Date(currentEndTime));
            let isStartSameEndDay = this.momentService.isSameDayTime(element.startTime, new Date(currentEndTime));
            let isEndSameEndDay = this.momentService.isSameDayTime(element.endTime, new Date(currentEndTime));
            if (existEndTime || isStartSameEndDay || isEndSameEndDay) {
              findArr.push(true);
            }
          }
        }
      });
    });
    return findArr?.length;
  }

  //Add Details
  addActualTiming(): void {
    if (!this?.config?.data?.addpermission) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    if (this.getactualTimingListArray.invalid) {
      this.getactualTimingListArray.markAllAsTouched();
      // this.focusInAndOutFormArrayFields();
      return;
    };
    if (this.onValidateExistTime()) {
      return this.snackbarService.openSnackbar('Time already exist');
    }
    let actualTimingListModel = new ActualTimingListModel(null);
    actualTimingListModel.appointmentId = this.config?.data?.initiationDetailsData?.appointmentInfo?.appointmentId ? this.config?.data?.initiationDetailsData?.appointmentInfo?.appointmentId : ''
    // actualTimingListModel.onRouteDate = this.config?.data?.initiationDetailsData.appointmentInfo.scheduledStartDate ? this.config?.data?.initiationDetailsData.appointmentInfo.scheduledStartDate : ""
    // actualTimingListModel.onRouteDate = actualTimingListModel.onRouteDate && actualTimingListModel.onRouteDate.split('T').length > 0 ? actualTimingListModel.onRouteDate.split('T')[0]: '';
    actualTimingListModel.onRouteDate = "";
    actualTimingListModel.createdUserId = this.config?.data?.userData.userId ? this.config?.data?.userData.userId : ''
    actualTimingListModel.modifiedUserId = this.config?.data?.userData.userId ? this.config?.data?.userData.userId : ''
    this.getactualTimingListArray.insert(0, this.createactualTimingListModel(actualTimingListModel));

    this.rxjsService.setFormChangeDetectionProperty(true);
  }

  removeActualTiming(i: number): void {
    if (!this?.config?.data?.deletepermission) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    if (!this.getactualTimingListArray.controls[i].value.appointmentActualTimingId) {
      this.getactualTimingListArray.removeAt(i);
      return;
    }
    const message = `Are you sure you want to delete this?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {

      maxWidth: "400px",
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (!dialogResult) return;
      if (this.getactualTimingListArray.controls[i].value.appointmentActualTimingId && this.getactualTimingListArray.length > 1) {

        this.crudService.delete(ModulesBasedApiSuffix.TECHNICIAN, this.config?.data?.data?.api,
          '',
          prepareRequiredHttpParams({
            appointmentActualTimingId: this.getactualTimingListArray.controls[i].value.appointmentActualTimingId,
            modifiedUserId: this.config?.data?.userData.userId
          })
        ).subscribe((response: IApplicationResponse) => {
          if (response.isSuccess) {
            this.getactualTimingListArray.removeAt(i);
            // this.isDuplicate = false;
            // this.isDuplicateNumber = false;
          }
          if (this.getactualTimingListArray.length === 0) {
            this.addActualTiming();
          };
        });
      }
      else {
        this.getactualTimingListArray.removeAt(i);
        // this.isDuplicate = false;
        // this.isDuplicateNumber = false;
      }
    });
    this.rxjsService.setFormChangeDetectionProperty(true);
  }

  onValidateRequiredTiming() {
    let findArr = [];
    this.actualTimingForm?.getRawValue()?.actualTimingList?.forEach((el: any, i: number) => {
      if (this.getactualTimingListArray?.controls[i]?.get('endTime')?.value && !this.getactualTimingListArray?.controls[i]?.get('startTime')?.value) {
        this.getactualTimingListArray?.controls[i]?.get('startTime')?.setErrors({ required: { formControlName: 'startTime' } });
        findArr.push(true);
      } else {
        this.getactualTimingListArray?.controls[i]?.get('onRouteTime')?.setErrors(null, { emitEvent: false });
        this.getactualTimingListArray?.controls[i]?.get('startTime')?.setErrors(null, { emitEvent: false });
        this.getactualTimingListArray?.controls[i]?.get('endTime')?.setErrors(null, { emitEvent: false });
      }
      this.getactualTimingListArray?.controls[i]?.get('onRouteTime')?.updateValueAndValidity({ emitEvent: false });
      this.getactualTimingListArray?.controls[i]?.get('startTime')?.updateValueAndValidity({ emitEvent: false });
      this.getactualTimingListArray?.controls[i]?.get('endTime')?.updateValueAndValidity({ emitEvent: false });
    });
    return findArr?.length;
  }

  onValidateTiming() {
    let findArr = [];
    this.actualTimingForm?.getRawValue()?.actualTimingList?.forEach((el: any, i: number) => {
      if (this.momentService.toHoursMints24(el?.onRouteTime) > this.momentService.toHoursMints24(el?.startTime) && el?.onRouteTime && el?.startTime) {
        this.getactualTimingListArray?.controls[i]?.get('startTime')?.setErrors({ lesserGreaterThan: true }, { emitEvent: false });
        this.getactualTimingListArray?.controls[i]?.get('onRouteTime')?.setErrors({ lesserGreaterThan: true }, { emitEvent: false });
        // this.getactualTimingListArray?.controls[i]?.get('startTime')?.setValue(null, {emitEvent: false});
        // this.getactualTimingListArray?.controls[i]?.get('onRouteTime')?.setValue(null, {emitEvent: false});
        findArr.push(true);
      } else if (this.momentService.toHoursMints24(el?.startTime) > this.momentService.toHoursMints24(el?.endTime) && el?.endTime && el?.startTime) {
        this.getactualTimingListArray?.controls[i]?.get('startTime')?.setErrors({ lesserGreaterThan: true }, { emitEvent: false });
        this.getactualTimingListArray?.controls[i]?.get('endTime')?.setErrors({ lesserGreaterThan: true }, { emitEvent: false });
        // this.getactualTimingListArray?.controls[i]?.get('startTime')?.setValue(null, {emitEvent: false});
        // this.getactualTimingListArray?.controls[i]?.get('endTime')?.setValue(null, {emitEvent: false});
        findArr.push(true);
      } else {
        this.getactualTimingListArray?.controls[i]?.get('onRouteTime')?.setErrors(null, { emitEvent: false });
        this.getactualTimingListArray?.controls[i]?.get('startTime')?.setErrors(null, { emitEvent: false });
        this.getactualTimingListArray?.controls[i]?.get('endTime')?.setErrors(null, { emitEvent: false });
      }
      this.getactualTimingListArray?.controls[i]?.get('onRouteTime')?.updateValueAndValidity({ emitEvent: false });
      this.getactualTimingListArray?.controls[i]?.get('startTime')?.updateValueAndValidity({ emitEvent: false });
      this.getactualTimingListArray?.controls[i]?.get('endTime')?.updateValueAndValidity({ emitEvent: false });
    });
    return findArr?.length;
  }

  onSubmitActualTiming() {
    if (!this?.config?.data?.addpermission) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    this.rxjsService.setFormChangeDetectionProperty(true); // Form submitt No changes snackbar prevent
    if (this.actualTimingForm.invalid) {
      this.actualTimingForm.markAllAsTouched();
      return
    }
    if (this.onValidateRequiredTiming()) {
      this.actualTimingForm.markAllAsTouched();
      return this.snackbarService.openSnackbar('OnRoute Time/Start Time/End Time is required');
      ;
    }
    if (this.onValidateTiming()) {
      this.actualTimingForm.markAllAsTouched();
      return this.snackbarService.openSnackbar('Start Time must be greater than On Route Time. End Time must be greater than Start Time.');
    }
    if (this.onValidateExistTime()) {
      return this.snackbarService.openSnackbar('Time already exist');
    }
    let formValue = this.actualTimingForm.getRawValue();
    formValue.actualTimingList.forEach((element: any) => {

      // if (element.onRouteDate) {
      //   let formateDate = element.onRouteDate.split("-")
      //   element.onRouteDate = element.onRouteDate ? formateDate[2] + '-' + formateDate[1] + '-' + formateDate[0] : null
      // }
      element.onRouteDate = element.onRouteDate ? this.momentService.isDateValid(element.onRouteDate) ? this.momentService.toFormateType(element.onRouteDate, 'YYYY-MM-DD') : element.onRouteDate : null
      element.startTime = element.startTime ? this.momentService.isDateValid(element.startTime) ? this.momentService.toFormateType(element.startTime, 'HH:mm') : element.startTime : null
      element.endTime = element.endTime ? this.momentService.isDateValid(element.endTime) ? this.momentService.toFormateType(element.endTime, 'HH:mm') : element.endTime : null
      element.onRouteTime = element.onRouteTime ? this.momentService.isDateValid(element.onRouteTime) ? this.momentService.toFormateType(element.onRouteTime, 'HH:mm') : element.onRouteTime : null
    });
    this.httpCancelService.cancelPendingRequestsOnFormSubmission();
    this.crudService.create(ModulesBasedApiSuffix.TECHNICIAN, this.config?.data?.api, formValue.actualTimingList)
      .subscribe((response: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        this.rxjsService.setDialogOpenProperty(false);
        if (response.isSuccess == true && response.statusCode == 200) {
          // this.actualTimeDialog = false
          // this.getCallInitiationDetailsById();
          this.dialogRef.close(true);
        }
      });

  }

}
